if (!customElements.get("about-us")) {
  class AboutUs extends HTMLElement {
    constructor() {
      super();

      const aboutUs = document.getElementById("splide__about-us");
      if (aboutUs) {
        this.aboutUsSplide = new Splide(aboutUs, {
          type: "loop",
          perPage: 1,
          lazyLoad: "sequential",
          arrows: false,
        });
      }
    }

    connectedCallback() {
      this.aboutUsSplide.mount();
    }
  }

  customElements.define("about-us", AboutUs);

  document.addEventListener("DOMContentLoaded", () => { 
    const AboutUsElement = document.createElement("about-us");
    document.body.appendChild(AboutUsElement);
  })
}
